import API from "../util/api";

export const getUSstate = async () => {
    let data = null;

    await API.get('/us-states')
        .then(res => {
            data = res.data.data;
        })
        .catch((err) => {
            throw new Error(JSON.stringify(err.response.data))
        });

    return data;
};

export const getCAstate = async () => {
    let data = null;

    await API.get('/ca-states')
        .then(res => {
            data = res.data.data;
        })
        .catch((err) => {
            throw new Error(JSON.stringify(err.response.data))
        });

    return data;
};

export const getCountries = async () => {
    let data = null;

    await API.get('/countries')
        .then(res => {
            data = res.data.data;
        })
        .catch((err) => {
            throw new Error(JSON.stringify(err.response.data))
        });

    return data;
};